import * as React from "react";
import { forwardRef } from "react";
const SvgTax = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M8 9H16",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8 15H13",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8 21H13",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22 9H24",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.5227 22.0853C19.1083 22.8556 20.0332 23.2912 21 23.252C22.5187 23.252 23.7493 22.328 23.7493 21.1893C23.7493 20.0507 22.5187 19.1267 21 19.1267C19.4813 19.1267 18.2493 18.2027 18.2493 17.0627C18.2493 15.9227 19.4813 15 21 15C21.9667 14.9613 22.8914 15.3968 23.4773 16.1667",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M21 23.252V24.6253",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M21 13.6267V15",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22 31C22.6225 29.9331 23.7648 29.2771 25 29.2771C26.2352 29.2771 27.3775 29.9331 28 31V1C27.376 2.06552 26.2348 2.72133 25 2.724C23.7651 2.7216 22.6238 2.06572 22 1C21.376 2.06552 20.2348 2.72133 19 2.724C17.7651 2.7216 16.6238 2.06572 16 1C15.376 2.06552 14.2348 2.72133 13 2.724C11.7651 2.7216 10.6238 2.06572 10 1C9.37599 2.06552 8.23479 2.72133 7 2.724C5.76514 2.7216 4.62381 2.06572 4 1V31C4.62251 29.9331 5.76479 29.2771 7 29.2771C8.23521 29.2771 9.37749 29.9331 10 31C10.6225 29.9331 11.7648 29.2771 13 29.2771C14.2352 29.2771 15.3775 29.9331 16 31",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16 31C16.6225 29.9331 17.7648 29.2771 19 29.2771C20.2352 29.2771 21.3775 29.9331 22 31",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgTax);
export default ForwardRef;
